import React from 'react';
import { Modal, Button } from 'antd';
import { primitiveColors } from '../../theming';
import classes from './styles.module.scss';

// onClose is Esc / a click outside: it defaults to onCancel, and a modal whose cancel button spends credits ("Buy New")
// passes its own, so dismissing it never buys anything (SC-QA-55)
const TemplateModal = ({
    title,
    content,
    isVisible,
    onCancel,
    onConfirm,
    onClose = onCancel,
    cancelText = 'No',
    confirmText = 'Yes',
}) => {
    return (
        <Modal
            title={<p className={classes['template_modal__title']}>{title}</p>}
            open={isVisible}
            onCancel={onClose}
            centered
            width={470}
            closeIcon={false}
            footer={
                <div className={classes['template_modal__footer']}>
                    <Button
                        key="no"
                        onClick={onCancel}
                        style={{
                            borderColor: primitiveColors.main,
                            color: primitiveColors.main,
                        }}
                    >
                        {cancelText}
                    </Button>
                    <Button
                        key="yes"
                        type="primary"
                        onClick={onConfirm}
                        style={{
                            backgroundColor: primitiveColors.main,
                            border: 'none',
                        }}
                    >
                        {confirmText}
                    </Button>
                </div>
            }
        >
            <div className={classes['template_modal__body']}>{content}</div>
        </Modal>
    );
};

export default TemplateModal;
